<!-- Yoinked from https://svelte.dev/examples/modal and svelte-simple-modal -->
<script>
	import { createEventDispatcher, onDestroy } from 'svelte';

	export let fullscreen = false;

	const dispatch = createEventDispatcher();
	const close = () => {
		enableScroll();
		dispatch('close');
	}

	let background;
	let wrap;
	let modal;

	const handleOuterClick = (event) => {
		if (event.target === background || event.target === wrap || event.target === modal) {
			close()
		}
	}

	let scrollY
	let prevBodyPosition;
	let prevBodyOverflow;
	let prevBodyWidth;

	const disableScroll = () => {
		scrollY = window.scrollY;
		prevBodyPosition = document.body.style.position;
		prevBodyOverflow = document.body.style.overflow;
		prevBodyWidth = document.body.style.width;
		document.body.style.position = 'fixed';
		document.body.style.top = `-${scrollY}px`;
		document.body.style.overflow = 'hidden';
		document.body.style.width = '100%';
	};

	const enableScroll = () => {
		document.body.style.position = prevBodyPosition || '';
		document.body.style.top = '';
		document.body.style.overflow = prevBodyOverflow || '';
		document.body.style.width = prevBodyWidth || '';
		window.scrollTo(0, scrollY);
	};

	disableScroll();

	const handle_keydown = e => {
		if (e.key === 'Escape') {
			close();
			return;
		}

		if (e.key === 'Tab') {
			// trap focus
			const nodes = modal.querySelectorAll('*');
			const tabbable = Array.from(nodes).filter(n => n.tabIndex >= 0);

			let index = tabbable.indexOf(document.activeElement);
			if (index === -1 && e.shiftKey) index = 0;

			index += tabbable.length + (e.shiftKey ? -1 : 1);
			index %= tabbable.length;

			tabbable[index].focus();
			e.preventDefault();
		}
	};

	const previously_focused = typeof document !== 'undefined' && document.activeElement;

	if (previously_focused) {
		onDestroy(() => {
			previously_focused.focus();
		});
	}
</script>

<svelte:window on:keydown={handle_keydown}/>

<div class="modal-background" on:click={handleOuterClick} bind:this={background}>
	<div class:fullscreen class="modal-wrap" on:click={handleOuterClick} bind:this={wrap}>
		<div class:fullscreen class="modal" role="dialog" aria-modal="true" bind:this={modal}>
			<slot class="content"></slot>
		</div>
	</div>
</div>

<style>
	* {
		box-sizing: border-box;
	}
	.modal-background {
		position: fixed;
		z-index: 1000;
		top: 0;
		left: 0;
		display: flex;
		flex-direction: column;
		justify-content: center;
		width: 100vw;
		height: 100vh;
		backdrop-filter: blur(2px);
	}

	.modal-wrap {
		position: relative;
		margin: 2rem;
		max-height: 100%;
	}

	.modal-wrap.fullscreen {
		margin: 0;
		height: 100vh;
	}

	.modal {
		position: relative;
		max-width: calc(100vw - 4rem);
		max-height: calc(80vh - 4rem);
		margin: 2rem auto;
		overflow: auto;
		filter: drop-shadow(0 0 15px black);
		height: 100%;
	}

	.content {
		position: relative;
		padding: 1rem;
		max-height: calc(100vh - 4rem);
		overflow: auto;
	}

	.modal.fullscreen {
		max-width: 100vw;
		max-height: 100vh;
		margin: 0;
		filter: none;
	}
</style>
